import Mooring from './Mooring';
export default class MooringPassingMark extends Mooring {
    mark;
    side;
    constructor(port, mark, side, freeText) {
        super(port, freeText);
        this.mark = mark;
        this.side = side;
    }
}
//# sourceMappingURL=MooringPassingMark.js.map